<template>
	<div class="main-containter" id="top" v-title data-title="北京和合网链科技有限公司">
		<PHeader :checkId="'公司简介29'"  :activeNames="'关于我们'"></PHeader>
		
		<article>
			<div style="height:150px;width:100%">
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" style="height: 100%;width: 100%;">
				<div class="fbannerUpText" style="position: absolute;top: 120px;color: white;font-weight: 600;font-size: 20px;left: calc(50% - 40px);">关于我们</div>
				<div class="fbannerUpText" style="position: absolute;top: 155px;color: white;font-size: 14px;left: calc(50% - 31px);">About Us</div>
			</div>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 / 关于我们</span>
				<span style="color:#333333;font-size:14px;"> / 公司简介</span>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;">公司简介</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;">Company Profile</div>
			<div style="margin-left: 3%;margin-top: 5px;width: 20px;height: 3px;background: #AA1100;"></div>
			<div style="margin-left: 3%;margin-top: 20px;width:94%;">
				<img style="width:100%;" src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/u5_div.png">
			</div>
			<div style="margin-top:20px;color:#8D8D8D;margin-left:3%;width:94%;">
				北京和合网链科技有限公司专注于健康检测、健康管理与调理服务，以量子检测技术和数字化健康管理平台为核心，为企业和个人提供全方位的健康解决方案。
			</div>
			<div style="margin-top:20px;color:#8D8D8D;margin-left:3%;width:94%;">
				中文名“北京和合网链科技有限公司”：寓意“健康为本、和合共生、科技赋能”，致力于用科技连接健康，让健康管理触手可及。公司名称承载着“以人为本、科技向善”的经营理念。
			</div>
			<div style="margin-top:20px;color:#8D8D8D;margin-left:3%;width:94%;">
				北京和合网链科技有限公司自成立以来，积极引进国内外先进的健康管理理念与医疗科技，践行“专业、精细”的服务理念，以助力客户健康为目标，以团队协作为基石，以数字化服务为依托，多年来赢得了众多医疗机构、企事业单位和客户的认可，在行业与社会各界享有良好的声誉。
			</div>
			<div style="margin-top:20px;color:#8D8D8D;margin-left:3%;width:94%;">
				公司健康管理团队多数具有医学、生物、信息技术等专业背景，能够在健康检测、健康管理、调理服务等多个领域提供专业的健康服务，并覆盖新能源、医疗健康、教育、金融、科技制造等众多行业的健康需求。
			</div>	
			<div style="margin-top:20px;color:#8D8D8D;margin-left:3%;width:94%;">
				北京和合网链科技有限公司自成立以来，坚持以科技创新驱动发展，在健康检测与数字化健康管理领域持续投入，先后服务多家医疗机构与健康管理平台，被行业评为“值得信赖的健康服务品牌”，助力全民健康事业发展。
			</div>
			<div style="margin-top:40px;margin-left:3%;width:94%;height:80px;text-align: center;">
				<div style="float:left;width:calc(22% - 2px);margin-right:1%;">
					<div style="color: #8D8D8D;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">专业人员</div>
					<div style="font-size: 24px;margin-top: 5px;font-weight: 900;color: #AA1100;">100+</div>
				</div>
				<div style="float:left;width:1px;height:30px;margin-top:15px;background-color:#D89088"></div>
				<div style="float:left;width:calc(28% - 2px);margin-left:1%;margin-right:1%;">
					<div style="color: #8D8D8D;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">分所及办事处</div>
					<div style="font-size: 24px;margin-top: 5px;font-weight: 900;color: #AA1100;">6</div>
				</div>
				<div style="float:left;width:1px;height:30px;margin-top:15px;background-color:#D89088"></div>
				<div style="float:left;width:calc(22% - 2px);margin-left:1%;margin-right:1%;">
					<div style="color: #8D8D8D;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">服务客户</div>
					<div style="font-size: 24px;margin-top: 5px;font-weight: 900;color: #AA1100;">500+</div>
				</div>
				<div style="float:left;width:1px;height:30px;margin-top:15px;background-color:#D89088"></div>
				<div style="float:left;width:calc(22% - 2px);margin-left:1%;">
					<div style="color: #8D8D8D;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">战略伙伴</div>
					<div style="font-size: 24px;margin-top: 5px;font-weight: 900;color: #AA1100;">50+</div>
				</div>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;">合作伙伴</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;">Partners</div>
			<div style="margin-left: 3%;margin-top: 5px;width: 20px;height: 3px;background: #AA1100;"></div>

			
			<el-carousel class="parentCarousel" style="height:200px;width:97%;margin-left:3%;margin-top:0px;" :autoplay="true">
				<el-carousel-item v-for="(item,index) in parentList" :key="'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/'+(index+1)+'.png'" style="height:100%;width:100%;">
					<!-- <img v-for="item2 in item" :key="'img'+item2+index" :style="{'margin-top':'20px',float:'left','margin-right':item2%2 != 0?'2%':'0','margin-left':item2%2 == 0?'2%':'0',width: 'calc(30% - 2px)','line-height':'65px',height: '65px',border: '1px solid #EAEAEA'}" :src="'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/'+(item2)+'.png'"> -->
					<img v-for="item2 in item" :key="'img'+item2+index" :style="{'margin-top':'20px',float:'left','margin-right':'3%',width: 'calc(30% - 2px)','line-height':'65px',height: '65px',border: '1px solid #EAEAEA'}" :src="'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/'+(item2)+'.png'">

				</el-carousel-item>
			</el-carousel>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				parentList:[
					[1,2,3,4,5,6],
					[7,8,9,10,11,12],
					[13,14,15,16,17,18],
					[19,20,21,22,23,24],
					[25,26,27,28,29,30],
					[31,32,33,34]
				]
			}
		},
		mounted() {
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
</style>
